import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import CheckboxSimple from "@components/tailwindComponents/CheckboxSimple";
import { SectionHolidayTableBulkHeader } from "./container/JobAndSalary/SectionHolidayTableBulk";
import { SectionPersonnalInfoTableBulkHeader } from "./container/PersonnalInformations/SectionPersonnalInfoTableBulk";
import { SectionEmailAndPhoneTableBulkHeader } from "./container/PersonnalInformations/SectionEmailAndPhoneTableBulk";
import { SectionAdressTableBulkHeader } from "./container/PersonnalInformations/SectionAdressTableBulk";
import { SectionHealthTableBulkHeader } from "./container/PersonnalInformations/SectionHealthTableBulk";
import { SectionClothesTableBulkHeader } from "./container/PersonnalInformations/SectionClothesTableBulk";
import { SectionFirstEmergencyTableBulkHeader } from "./container/PersonnalInformations/SectionFirstEmergencyTableBulk";
import { SectionSecondEmergencyTableBulkHeader } from "./container/PersonnalInformations/SectionSecondEmergencyTableBulk";
import { SectionJobTableBulkHeader } from "./container/JobAndSalary/SectionJobTableBulk";
import { SectionSecurityTableBulkHeader } from "./container/JobAndSalary/SectionSecurityTableBulk";
import { SectionInsuranceBankingTableBulkHeader } from "./container/JobAndSalary/SectionInsuranceBankingTableBulk";
import { SectionCourseAndSalaryTableBulkHeader } from "./container/JobAndSalary/SectionCourseAndSalaryTableBulk";
import { SectionAdditionalInfoTableBulkHeader } from "./container/PersonnalInformations/SectionAdditionalInfoTableBulk";

const ItemBulkEditHeader = ({
  employees,
  useTimeBank,
  onSelectAll,
  allSelected,
  mustWait,
  maxAdvantageTypes,
  hiddenColumns = {}
}) => {
  const { t: mainTranslator } = useTranslation("pages.employés.emploi&Salary");

  const isColumnVisible = useCallback((sectionKey) => {
    if (!employees.length) return false;

    return employees.some((employee) => {
      if (!employee?.visibleSections) return false;
      return (
        employee.visibleSections?.jobSalaryHolidays?.includes(sectionKey) ||
        employee.visibleSections?.personalInfo?.includes(sectionKey)
      );
    });
  }, [employees]);

  return (
    <tr className="arh-sticky arh-border-x-0 arh-border-b arh-border-t-0 arh-border-solid arh-border-borderTable">
      <th
        key="employee"
        className="arh-w-1/4 arh-bg-greyColor arh-px-[1.125rem] arh-py-[10px] arh-text-xs arh-font-semibold arh-text-darkColor arh-sticky arh-left-0 arh-z-10"
      >
        <div className="arh-flex arh-items-center">
          <CheckboxSimple
            name="Employé"
            onClick={onSelectAll}
            haveHover={false}
            checked={allSelected}
            variant="green"
            className="arh-mr-2"
            disabled={mustWait}
          />
          {mainTranslator("Employé")}
        </div>
      </th>
      {isColumnVisible("hoursPerDayAndBalance") && (
        <SectionHolidayTableBulkHeader
          key="holiday-section"
          employees={employees}
          useTimeBank={useTimeBank}
          hiddenColumns={hiddenColumns}
        />
      )}
      {isColumnVisible("personalInfos") && (
        <SectionPersonnalInfoTableBulkHeader key="personal-info" hiddenColumns={hiddenColumns} />
      )}
      {isColumnVisible("emailsAndPhones") && (
        <SectionEmailAndPhoneTableBulkHeader key="email-phone" hiddenColumns={hiddenColumns} />
      )}
      {isColumnVisible("address") && (
        <SectionAdressTableBulkHeader key="address" hiddenColumns={hiddenColumns} />
      )}
      {isColumnVisible("healthAllergiesFoodPrefs") && (
        <SectionHealthTableBulkHeader key="health" hiddenColumns={hiddenColumns} />
      )}
      {isColumnVisible("clothingSize") && (
        <SectionClothesTableBulkHeader key="clothes" hiddenColumns={hiddenColumns} />
      )}
      {isColumnVisible("firstContact") && (
        <SectionFirstEmergencyTableBulkHeader key="first-emergency" hiddenColumns={hiddenColumns} />
      )}
      {isColumnVisible("secondContact") && (
        <SectionSecondEmergencyTableBulkHeader key="second-emergency" hiddenColumns={hiddenColumns} />
      )}
      {isColumnVisible("job") && (
        <SectionJobTableBulkHeader key="job" hiddenColumns={hiddenColumns} />
      )}
      {isColumnVisible("security") && (
        <SectionSecurityTableBulkHeader key="security" hiddenColumns={hiddenColumns} />
      )}
      {isColumnVisible("salaryAndAdvantages") && (
        <SectionCourseAndSalaryTableBulkHeader
          key="salary-and-advantages"
          maxAdvantageTypes={maxAdvantageTypes}
          hiddenColumns={hiddenColumns}
        />
      )}
      {isColumnVisible("bankingAndInsuranceInformation") && (
        <SectionInsuranceBankingTableBulkHeader key="banking-insurance" hiddenColumns={hiddenColumns} />
      )}
      {
        isColumnVisible("additionalInformation") && (
          <SectionAdditionalInfoTableBulkHeader key="additional-info" hiddenColumns={hiddenColumns} />
        )
      }
    </tr>
  );
};

export default ItemBulkEditHeader;